<template>
  <div class="base-mit-chart-bar">
      <canvas :id="chartId"></canvas>
  </div>
</template>

<script>
  import Chart from 'chart.js/auto';

export default {
  name: 'BaseMitChartBasic',
  components: {
  },
  props: {
    chartId:{
        default: 'mitChartId',
        type: String
    },
    dataSets:{
        default() {
            return {
                labels:['January','February','March','April','May','June','July'],
                sets:[
                    {
                        label: 'Example 1',
                        data: [2, 45, 88, 0, 79, 0, 0],
                        //borderColor: null,
                        //backgroundColor: null,
                        //borderWidth: 2,
                        //borderRadius: Number.MAX_VALUE,
                        //borderSkipped: false,
                    },
                    {
                        label: 'Example 2',
                        data: [8, 33, 96, 5, 0, 60, 20],
                        // borderColor: null,
                        // backgroundColor: null,
                        // borderWidth: 2,
                        // borderRadius: 5,
                        // borderSkipped: false,
                    }
                ]
            }
        },
        type: Object
    },
    chartType:{
        default: 'bar', //line, pie
        type: String
    },
    title: {
        default: 'Default Title',
        type: String
    },
    legend: {
        default: null, //top,bottom
        type: String
    },
    labelX:{
        default: 'Default X Label',
        type: String
    },
    labelY:{
        default: 'Default Y Label',
        type: String
    },
    horizontal:{
        default: false,
        type: Boolean
    },
    borderRadius:{
        default: 0,
        type: Number
    },
    borderWidth:{
        default: 1,
        type: Number
    },
    backgroundColor: {
        default() {
            return [
                'rgba(255, 99, 132, 0.4)',
                'rgba(54, 162, 235, 0.4)',
                'rgba(255, 206, 86, 0.4)',
                'rgba(75, 192, 192, 0.4)',
                'rgba(153, 102, 255, 0.4)'
            ]
        },
        type: Array
    },
    borderColor: {
        default() {
            return [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)'
            ]
        },
        type: Array
    }
  },
  data: function() {
    return {
    }
  },
  created() {
  },
  mounted() {
      this.setDataSetDefaults(this.dataSets.sets)
      const htmlChart= document.getElementById(this.chartId);
      let chartConfig = {
            type: this.chartType,
            data: {
                labels: this.dataSets.labels,
                datasets: this.dataSets.sets
            },
            options: {
                indexAxis: this.horizontal ? 'y' : 'x',
                responsive: true,
                plugins: {
                  legend: {
                    position: this.legend,
                  }
                },
                scales: {
                    // x: {
                    //     ticks: {
                    //         // Include a dollar sign in the ticks
                    //         callback: (index) => {
                    //             let label = this.barData.labels[index];
                    //             if(label.length > 20){
                    //                 let arr = label.split('/');
                    //                 return '.../'+arr[arr.length-1];
                    //             }
                    //             return label;
                    //         }
                    //     }
                    // },
                    x: {
                        beginAtZero: false,
                        //type: 'logarithmic'
                    },
                    y: {
                        beginAtZero: false
                        //type: 'logarithmic'
                    }
                }
            }
        };
        if(this.title !== null && this.title.length > 0){
            chartConfig.options.plugins.title = {
                            display: true,
                            text: this.title
                        };
        }
        if(this.labelX !== null && this.labelX.length > 0){
            chartConfig.options.scales.x.title = {
                            display: true,
                            text: this.labelX
                        };
        }
        if(this.labelY !== null && this.labelY.length > 0){
            chartConfig.options.scales.y.title = {
                            display: true,
                            text: this.labelY
                        };
        }
        if(this.chartType === 'pie'){
            delete chartConfig.options.scales;
        }
      const chart = new Chart(htmlChart, chartConfig);
  },
  methods : {
    setDataSetDefaults(dataSets){
        
        for(let x = 0; x < dataSets.length; x++){
            if(this.chartType === 'pie'){
                if(typeof dataSets[x].borderColor === 'undefined' || dataSets[x].borderColor === null){
                    dataSets[x].borderColor = this.borderColor;
                }
                if(typeof dataSets[x].backgroundColor === 'undefined' || dataSets[x].backgroundColor === null){
                    dataSets[x].backgroundColor = this.backgroundColor;
                }
            }
            else{
                if(typeof dataSets[x].borderColor === 'undefined' || dataSets[x].borderColor === null){
                    dataSets[x].borderColor = this.borderColor[x];
                }
                if(typeof dataSets[x].backgroundColor === 'undefined' || dataSets[x].backgroundColor === null){
                    dataSets[x].backgroundColor = this.backgroundColor[x];
                }
            }
            dataSets[x].borderWidth = this.borderWidth;
            dataSets[x].borderRadius = this.borderRadius;
        }

        
       
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
